import { ITableColumn, SuperButton } from '@devinforius/super-compos-17';
import { SuperTabsXl } from 'src/app/shared/models/super-tabs-xl';
import { addDays } from 'date-fns';
import { HomeScanComponent } from './home-scan.component';
import { TranslateService } from '@devinforius/super-compos-17';
import { ITableCategoryAction } from '@devinforius/super-compos-17/lib/i-table/models/i-table-category-action.model';
import { ScanFromDelibe } from 'src/app/shared/models/iScanV1/scan-from-delibe';

export function getButtonTitle(component: HomeScanComponent, translater: TranslateService): Array<SuperButton & {loading: boolean}> {
  return [{
    text: translater.translate('iscan.global.newScan'),
    styleClass: 'green',
    icon: 'bi bi-plus-circle-fill',
    iconPosition: 'left',
    loading: false,
    click: (): void => {
      component.openFileSelector();
    },
  }];
}

export function getColumnsScan(): ITableColumn[] {
  return [
    {
      field: 'filename',
      header: 'Nom',
      width: '52%',
    },
    {
      field: 'pagesCount',
      header: 'Pages',
      width: '7%',
      format: (value) => {
        if (value) {
          if (value === null) {
            return `-`;
          } else {
            return value;
          }
        }
      }
    },
    {
      field: 'uploadDate',
      header: 'Date d\'import',
      width: '20%',
      format: (value) => {
        if (value) {
          const date = new Date(value);
          return new Intl.DateTimeFormat('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          }).format(date);
        }
        return value;
      },
    },{
      field: 'lastTransition.statutId',
      header: 'Status',
      width: '15%',
      format: (value, element) => {
        const dateExpired = addDays(new Date(element.lastTransition.date), 1);
        if (value) {
          if (value === 1 && dateExpired > new Date()) {
            return `
              <div class='status-orange-scan'>
                <span>En création </span>
                <span class="dot dot--one">.</span><span class="dot dot--two">.</span><span class="dot dot--three">.</span>
              </div>`;
          } else if (value === 1 && dateExpired < new Date()) {
            return `<div class='status-orange-scan'>
                <span>Traitement tardif<br>
                <span class="dot--one">Contacter le support</span>
                </span>
                
              </div>`;
          } else if (value === 2) {
            return `<div class='status-blue'> À traiter </div>`;
          } else {
            return `<div class='status-green'> Traité </div>`;
          }
        }
        return value;
      }
    }
  ];
}

export function getColumnsDocumentLink(): ITableColumn[] {
  return [
    {
      field: 'id',
      header: 'Id',
      width: '10%',
      format: (_, element) => {
        if(element.pointId){
          return element.pointId;
        } else if(element.seanceId){
          return element.seanceId;
        } else {
          return 'Unknown';
        }
      }
    },
    {
      field: 'objetSynthese',
      header: 'Nom',
      width: '70%',
      maxWidth: '200px',
      format: (_, element) => {
        if(element.pointId){
          return element.pointObjetSynthese;
        } else if(element.seanceId){
          return element.seanceDescription;
        } else {
          return 'Unknown';
        }
      }
    },
    {
      field: 'type',
      header: 'Type',
      width: '20%',
      format: (_, element) => {
        if(element.pointId){
          return 'Point';
        } else if(element.seanceId){
          return 'Séance';
        } else {
          return 'Unknown';
        }
      }
    },
  ];
}

export function getTabsScan(): Array<SuperTabsXl> {
  return [
    {
      header: 'A traiter',
      id: 'toTreat',
      icon: 'bi bi-folder2-open',
    },
    {
      header: 'Traité',
      id: 'treated',
      icon: 'bi bi-lock',
    },
    {
      header: 'Historique',
      id: 'history',
      icon: 'bi bi-archive',
    },
  ];
}

export function getMenuCase1(component: HomeScanComponent, translater: TranslateService): ITableCategoryAction[] {
  return [
    {
      label: '',
      actions: [
        {
          label: translater.translate('iscan.actions.modifyScan'),
          icon: 'bi bi-pencil-square',
          tooltip: translater.translate('iscan.actions.modifyScan'),
          action: (event: ScanFromDelibe): void => {
            component.modifyScan(event);
          },
          condition: true,
        },
      ],
    },{
      label: '',
      actions: [
        {
          label: translater.translate('iscan.actions.downloadDocument'),
          icon: 'bi bi-download',
          tooltip: translater.translate('iscan.actions.downloadDocument'),
          action: (event: ScanFromDelibe): void => {
            component.downloadDocument(event);
          },
          condition: true,
        },
      ],
    },{
      label: '',
      actions: [
        {
          label: translater.translate('iscan.actions.abortScan'),
          icon: 'bi bi-trash3-fill',
          tooltip: translater.translate('iscan.actions.abortScan'),
          action: (event: ScanFromDelibe): void => {
            component.verifyStatusDeleteScan(event);
          },
          condition: true,
        },
      ],
    },
  ]; 
}

export function getMenuCase2(component: HomeScanComponent, translater: TranslateService): ITableCategoryAction[] {
  return [
    {
      label: '',
      actions: [
        {
          label: translater.translate('iscan.actions.seeScan'),
          icon: 'bi bi-eye-fill',
          tooltip: translater.translate('iscan.actions.seeScan'),
          action: (event: ScanFromDelibe): void => {
            component.openDialogDocumentLink = true;
            component.getItemsDocumentLink(event);
          },
          condition: true,
        },
      ],
    },
  ];
}